document.addEventListener("click", function (e) {
	if (e.target.classList.contains("js-toggleMenuItem")) {
        e.preventDefault();

        var item = e.target.closest(".c-expand-menu__item");
        item?.classList.toggle("is-active");
	}
});
